import hotToast from 'react-hot-toast';

class Toast {
  success(message: string) {
    hotToast.success(message);
  }

  error(message: string) {
    hotToast.error(message);
  }

  info(message: string) {
    hotToast(message, { icon: 'ℹ️' });
  }

  warning(message: string) {
    hotToast(message, { icon: '⚠️' });
  }
}

export const toast = new Toast();
